import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppDataService, ConfigService } from 'app/services';

export enum SideMenuSupportEnum {
    Drivers = 1,
    Customers = 2,
};

@Component({
    selector: 'support-root',
    templateUrl: './support-root.component.html',
    styleUrls: ['./support-root.component.scss'],
    providers: [MessageService]
})
export class SupportRootComponent implements OnInit {

    public activeMenu: SideMenuSupportEnum = SideMenuSupportEnum.Drivers;
    public menuEnum = SideMenuSupportEnum;

    public selectGeoZone: any;

    constructor(public appData: AppDataService,
        public configService: ConfigService) { }

    ngOnInit(): void {
    }

    public handleSideMenuClick(tab: SideMenuSupportEnum): void {
        this.activeMenu = tab;
    }

    changedGeoZoneEmit(item: any) {
        this.selectGeoZone = item;
    }
}
